import iconLocpoint from '@/assets/map-icons/icon-locpoint.png'
import iconBld from '@/assets/map-icons/icon-bld.png'
import iconArea from '@/assets/map-icons/icon-area.png'

export const MAP_ICON_SIZE = 32
/** 施工图 marker 图标区 20×20，含标签总高 32（20+12） */
export const DWG_MARKER_ICON_SIZE = 20
/** 微基站/区域/楼栋图标区 36×36（相对作业人员 20×20 加 0.8 倍） */
export const DWG_MARKER_FACILITY_ICON_SIZE = 36
export const DWG_MARKER_LABEL_HEIGHT = 12
export const DWG_MARKER_TOTAL_HEIGHT = DWG_MARKER_ICON_SIZE + DWG_MARKER_LABEL_HEIGHT
export const DWG_MARKER_LABEL_MAX = 10
export const DWG_GLYPH_W = DWG_MARKER_ICON_SIZE
const STATION_TIGHT_VIEWBOX = '9.5 4.5 13 21'
const STATION_TIGHT_RATIO = 21 / 13
const BEACON_TIGHT_VIEWBOX = '4 1 23 38'
const BEACON_TIGHT_RATIO = 38 / 23
export const BEACON_DEFAULT_COLOR = '#df2e06'
export const BEACON_ICON_RATIO = 40 / 32

export const STATION_DEFAULT_COLOR = '#64748B'
export const STATION_OFFLINE_COLOR = '#000000'
export const STATION_ENTER_COLOR = '#15803D'
export const STATION_EXIT_COLOR = '#EA580C'

const STATION_TAG_THEME = {
  0: {
    color: '#334155',
    borderColor: '#94A3B8',
    backgroundColor: '#E2E8F0'
  },
  1: {
    color: '#14532D',
    borderColor: '#22C55E',
    backgroundColor: '#BBF7D0'
  },
  2: {
    color: '#9A3412',
    borderColor: '#F97316',
    backgroundColor: '#FED7AA'
  }
}

export function entranceTypeTagStyle(type) {
  const theme = STATION_TAG_THEME[Number(type) || 0] || STATION_TAG_THEME[0]
  return {
    color: theme.color,
    borderColor: theme.borderColor,
    backgroundColor: theme.backgroundColor
  }
}

export function stationMarkerLabel(station) {
  if (!station) return '微基站'
  const name = String(station.name || '').trim()
  return name || '微基站'
}

export function stationColorByEntranceType(type) {
  const t = Number(type) || 0
  if (t === 1) return STATION_ENTER_COLOR
  if (t === 2) return STATION_EXIT_COLOR
  return STATION_DEFAULT_COLOR
}

/** 微基站图标：三角塔 + 发射点 + 双侧信号弧（与用户提供的 icon-station 造型一致） */
function stationSvgPaths(fill) {
  const esc = escapeHtml(fill)
  return [
    `<path fill="${esc}" d="M16 24.8 10.2 16.2h11.6Z"/>`,
    `<circle cx="16" cy="9.6" r="1.9" fill="${esc}"/>`,
    `<path fill="none" stroke="${esc}" stroke-width="2" stroke-linecap="round" d="M14.35 8.05a2.65 2.65 0 0 0 0 3.1"/>`,
    `<path fill="none" stroke="${esc}" stroke-width="2" stroke-linecap="round" d="M13.05 5.75a5.1 5.1 0 0 0 0 7.7"/>`,
    `<path fill="none" stroke="${esc}" stroke-width="2" stroke-linecap="round" d="M17.65 8.05a2.65 2.65 0 0 1 0 3.1"/>`,
    `<path fill="none" stroke="${esc}" stroke-width="2" stroke-linecap="round" d="M18.95 5.75a5.1 5.1 0 0 1 0 7.7"/>`
  ].join('')
}

export function stationSvgHtml(color = STATION_DEFAULT_COLOR, size = MAP_ICON_SIZE, options = {}) {
  const fill = sanitizeMarkerColor(color) || STATION_DEFAULT_COLOR
  if (options.dwgGlyph) {
    const w = options.boxW != null ? options.boxW : DWG_GLYPH_W
    const h = options.boxH != null ? options.boxH : Math.round(w * STATION_TIGHT_RATIO)
    return `<svg class="station-svg" xmlns="http://www.w3.org/2000/svg" viewBox="${STATION_TIGHT_VIEWBOX}" width="${w}" height="${h}" preserveAspectRatio="xMidYMax meet" aria-hidden="true">${stationSvgPaths(fill)}</svg>`
  }
  return `<svg class="station-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="${size}" height="${size}" aria-hidden="true">${stationSvgPaths(fill)}</svg>`
}

export function stationIconDataUrl(color = STATION_DEFAULT_COLOR, size = MAP_ICON_SIZE) {
  const svg = stationSvgHtml(color, size).replace(/\s+/g, ' ').trim()
  return `data:image/svg+xml,${encodeURIComponent(svg)}`
}

export const STATION_LEGEND_ICON = stationIconDataUrl(STATION_DEFAULT_COLOR, MAP_ICON_SIZE)

/** 作业人员定位针 SVG 轮廓（单 path，fill 可动态替换） */
const BEACON_HELMET_PATH = [
  'M16 1.5C9.8 1.5 5.2 4.8 4.2 9.4V11c0 .4.1.8.4 1.1L6 14.8h20l1.4-2.7c.3-.3.4-.7.4-1.1V9.4C26.8 4.8 22.2 1.5 16 1.5z',
  'M7.8 3.8c1.8-1.4 4.5-2.1 8.2-2.1s6.4.7 8.2 2.1c.8.6 1.4 1.4 1.8 2.3H6c.4-.9 1-1.7 1.8-2.3z',
  'M5.2 16.8 15.2 36.8h1.6L26.8 16.8H5.2z',
  'M16 38.6a2.4 1.3 0 1 0 0-2.6 2.4 1.3 0 0 0 0 2.6z'
].join('')

export function sanitizeMarkerColor(color) {
  if (!color) return ''
  const value = String(color).trim()
  if (/^#[0-9A-Fa-f]{3,8}$/.test(value)) return value
  if (/^rgba?\(.+\)$/.test(value)) return value
  return ''
}

export function resolveBeaconColor(beacon, jobTypes = []) {
  const fromDevice = sanitizeMarkerColor(beacon && beacon.color)
  if (fromDevice) return fromDevice

  const jobTypeId = beacon && beacon.jobTypeId
  const id = Number(jobTypeId)
  if (id) {
    const jt = jobTypes.find(j => Number(j.id) === id)
    const fromJobType = sanitizeMarkerColor(jt && jt.color)
    if (fromJobType) return fromJobType
  }
  return BEACON_DEFAULT_COLOR
}

export function beaconHelmetSvgHtml(color = BEACON_DEFAULT_COLOR, size = MAP_ICON_SIZE, options = {}) {
  const fill = sanitizeMarkerColor(color) || BEACON_DEFAULT_COLOR
  const boxW = options.boxW
  const boxH = options.boxH
  if (boxW != null && boxH != null) {
    const viewBox = options.tightViewBox === false ? '0 0 32 40' : BEACON_TIGHT_VIEWBOX
    return `<svg class="beacon-helmet-svg" xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}" width="${boxW}" height="${boxH}" preserveAspectRatio="xMidYMax meet" aria-hidden="true"><path fill="${escapeHtml(fill)}" d="${BEACON_HELMET_PATH}"/></svg>`
  }
  const fitSquare = options.fitSquare === true
  const height = fitSquare ? size : Math.round(size * BEACON_ICON_RATIO)
  const ratioAttr = fitSquare ? ' preserveAspectRatio="xMidYMax meet"' : ''
  return `<svg class="beacon-helmet-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 40" width="${size}" height="${height}"${ratioAttr} aria-hidden="true"><path fill="${escapeHtml(fill)}" d="${BEACON_HELMET_PATH}"/></svg>`
}

const DWG_FACILITY_ICON_TYPES = new Set(['station', 'area', 'bld'])

export function dwgMarkerIconSize(iconType) {
  return DWG_FACILITY_ICON_TYPES.has(normalizeMapIconType(iconType))
    ? DWG_MARKER_FACILITY_ICON_SIZE
    : DWG_MARKER_ICON_SIZE
}

/** 施工图 marker 图标尺寸（正方形图标区，SVG 内 meet 缩放） */
export function dwgGlyphSize(iconType, containerSize) {
  const size = containerSize != null ? containerSize : dwgMarkerIconSize(iconType)
  return { w: size, h: size }
}

export function dwgMarkerTooltipOffset(iconType) {
  const size = dwgMarkerIconSize(iconType)
  return [0, -(size / 2 + 6)]
}

export function beaconIconDataUrl(color = BEACON_DEFAULT_COLOR, size = MAP_ICON_SIZE) {
  const svg = beaconHelmetSvgHtml(color, size).replace(/\s+/g, ' ').trim()
  return `data:image/svg+xml,${encodeURIComponent(svg)}`
}

export const BEACON_LEGEND_ICON = beaconIconDataUrl(BEACON_DEFAULT_COLOR, MAP_ICON_SIZE)

export function truncateMarkerLabel(label, maxLen = DWG_MARKER_LABEL_MAX) {
  const text = String(label || '').trim()
  if (!text) return ''
  if (text.length <= maxLen) return text
  return `${text.slice(0, maxLen)}…`
}

export const MAP_ICONS = {
  station: STATION_LEGEND_ICON,
  locpoint: iconLocpoint,
  bld: iconBld,
  region: iconBld,
  area: iconArea,
  beacon: BEACON_LEGEND_ICON,
  worker: BEACON_LEGEND_ICON
}

export function mapIconUrl(type, options = {}) {
  const iconType = normalizeMapIconType(type)
  if (iconType === 'beacon') {
    return beaconIconDataUrl(options.color || BEACON_DEFAULT_COLOR, options.size || MAP_ICON_SIZE)
  }
  if (iconType === 'station') {
    return stationIconDataUrl(options.color || STATION_DEFAULT_COLOR, options.size || MAP_ICON_SIZE)
  }
  return MAP_ICONS[iconType] || MAP_ICONS.station
}

export function normalizeMapIconType(type) {
  if (type === 'region') return 'bld'
  if (type === 'worker') return 'beacon'
  return type || 'beacon'
}

function markerIconHtml(iconType, options = {}) {
  const { size = MAP_ICON_SIZE, color } = options
  if (iconType === 'beacon') {
    return beaconHelmetSvgHtml(color, size)
  }
  if (iconType === 'station') {
    return stationSvgHtml(color, size)
  }
  const src = mapIconUrl(iconType, { size })
  return `<img src="${src}" width="${size}" height="${size}" alt="" draggable="false"/>`
}

export function amapMarkerHtml(type, options = {}) {
  const { label = '', size = MAP_ICON_SIZE, anchor = 'center', color } = options
  const iconType = normalizeMapIconType(type)
  const labelHtml = label
    ? `<span class="map-mk-label">${escapeHtml(label)}</span>`
    : ''
  const anchorClass = anchor === 'bottom-center' ? ' map-mk--bottom' : ''
  const iconHtml = markerIconHtml(iconType, { size, color })
  return `<div class="map-mk map-mk--${iconType}${anchorClass}">
    ${iconHtml}
    ${labelHtml}
  </div>`
}

export function createLeafletMapIcon(L, type, size = MAP_ICON_SIZE, options = {}) {
  const iconType = normalizeMapIconType(type)
  if (iconType === 'beacon') {
    const height = Math.round(size * BEACON_ICON_RATIO)
    return L.divIcon({
      className: `map-leaflet-icon map-leaflet-icon--${iconType}`,
      html: beaconHelmetSvgHtml(options.color, size),
      iconSize: [size, height],
      iconAnchor: [size / 2, height],
      tooltipAnchor: [0, height / 2 + 4]
    })
  }
  if (iconType === 'station') {
    return L.divIcon({
      className: `map-leaflet-icon map-leaflet-icon--${iconType}`,
      html: stationSvgHtml(options.color, size),
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
      tooltipAnchor: [0, size / 2 + 4]
    })
  }
  return L.icon({
    iconUrl: mapIconUrl(iconType),
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    tooltipAnchor: [0, size / 2 + 4],
    className: `map-leaflet-icon map-leaflet-icon--${iconType}`
  })
}

/** 室内图：图标与名称一体，间距更紧凑 */
export function createLeafletDwgMarkerIcon(L, type, label, options = {}) {
  const { highlight = false, color } = options
  const iconType = normalizeMapIconType(type)
  const markerSize = dwgMarkerIconSize(iconType)
  if (iconType === 'vertex') {
    const dotColor = sanitizeMarkerColor(color) || '#2F6BFF'
    const dotSize = 10
    const html = `<div class="dwg-marker dwg-marker--vertex">
      <span class="dwg-marker-vertex" style="background:${escapeHtml(dotColor)}"></span>
    </div>`
    return L.divIcon({
      className: 'dwg-marker-wrap dwg-marker-wrap--vertex',
      html,
      iconSize: [dotSize, dotSize],
      iconAnchor: [dotSize / 2, dotSize / 2]
    })
  }
  const fullLabel = String(label || '').trim()
  const displayLabel = truncateMarkerLabel(fullLabel)
  const labelHtml = fullLabel
    ? `<span class="dwg-marker-label dwg-marker-label--${iconType}">${escapeHtml(displayLabel)}</span>`
    : ''
  const labelHeight = label ? DWG_MARKER_LABEL_HEIGHT : 0
  const ringHtml = highlight ? '<span class="dwg-marker-ring" aria-hidden="true"></span>' : ''
  const iconHeight = markerSize
  const glyph = dwgGlyphSize(iconType, markerSize)
  const iconInner = iconType === 'beacon'
    ? beaconHelmetSvgHtml(color, markerSize, { boxW: glyph.w, boxH: glyph.h })
    : iconType === 'station'
      ? stationSvgHtml(color || STATION_DEFAULT_COLOR, markerSize, { dwgGlyph: true, boxW: glyph.w, boxH: glyph.h })
      : `<img class="dwg-marker-img" src="${mapIconUrl(iconType, { size: markerSize })}" width="${glyph.w}" height="${glyph.h}" alt="" draggable="false"/>`
  const offline = options.offline === true
  const pulseHtml = iconType === 'station' && !offline
    ? '<span class="dwg-station-pulse" aria-hidden="true"></span><span class="dwg-station-pulse dwg-station-pulse--2" aria-hidden="true"></span>'
    : ''
  const html = `<div class="dwg-marker dwg-marker--${iconType}${highlight ? ' is-highlight' : ''}${offline ? ' is-offline' : ''}">
    <div class="dwg-marker-icon">
      ${pulseHtml}
      ${ringHtml}
      ${iconInner}
    </div>
    ${labelHtml}
  </div>`
  const isPin = iconType === 'locpoint' || iconType === 'beacon'
  return L.divIcon({
    className: 'dwg-marker-wrap',
    html,
    iconSize: [markerSize, iconHeight + labelHeight],
    iconAnchor: isPin ? [markerSize / 2, iconHeight] : [markerSize / 2, markerSize / 2]
  })
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
